import type { SessionTenantType } from '@bliks-io/contracts';

/**
 * The minimum a caller must know to place a session. Structural, not
 * `Pick<SignInResponse, …>`, so the root route can answer the same question
 * from the auth-store snapshot instead of restating the policy.
 */
interface SignedInSession {
  tenantType: SessionTenantType | null;
  tenant: { slug: string };
}

/**
 * Where a signed-in user belongs: platform staff on the platform entrance,
 * partners in the partner area, everyone else on their organization page.
 * Shared by password sign-in, the SSO callback and the root route so the policy
 * cannot drift between them.
 *
 * `/admin` und nicht mehr fest `/admin/tenants`: welche Seite die erste ist,
 * hängt seit ADR 0042 an der Rolle, und der Einstieg entscheidet das. Ein
 * Vertriebler landete sonst auf den Arbeitsbereichen — einer Seite, die in
 * seinem Menü gar nicht steht.
 */
export function signedInDestination({ tenantType, tenant }: SignedInSession) {
  if (tenantType === 'super') {
    return { to: '/admin' } as const;
  }
  if (tenantType === 'partner') {
    return { to: '/partner' } as const;
  }
  return { to: '/$slug', params: { slug: tenant.slug } } as const;
}

/**
 * Same policy as a plain URL path, for flows that leave the SPA (workspace
 * switching does a full page load).
 */
export function signedInPath({ tenantType, tenant }: SignedInSession): string {
  if (tenantType === 'super') return '/admin';
  if (tenantType === 'partner') return '/partner';
  return `/${tenant.slug}`;
}
